function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import { Form } from 'reactstrap';

var ResourceFormContent = function ResourceFormContent(_ref) {
  var formContent = _ref.formContent,
      formik = _ref.formik,
      subChildren = _ref.subChildren,
      submitting = _ref.submitting,
      resource = _ref.resource,
      mapping = _ref.mapping,
      renderSubmit = _ref.renderSubmit,
      renderBackToList = _ref.renderBackToList,
      renderActions = _ref.renderActions,
      fetch = _ref.fetch,
      setSubmitting = _ref.setSubmitting;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      initContext = _useState2[0],
      setInitContext = _useState2[1];

  var FormContent = formContent;
  useEffect(function () {
    formik.setFormikState(_objectSpread(_objectSpread({}, formik), {}, {
      resource: resource,
      mapping: mapping
    }));
    setInitContext(false);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (initContext || !FormContent) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: formik.handleSubmit,
    noValidate: true
  }, /*#__PURE__*/React.createElement(FormContent, _extends({}, formik, {
    mapping: mapping,
    resource: resource,
    submitting: submitting,
    fetch: fetch,
    setSubmitting: setSubmitting,
    renderSubmit: renderSubmit,
    renderBackToList: renderBackToList,
    renderActions: renderActions
  })), subChildren);
};

export default ResourceFormContent;